import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AlertCircle, Loader2, Lock } from "lucide-react";
import { BrandLogo } from "../components/BrandLogo";
import { LegalFooter } from "../components/LegalFooter";
import { useAuth } from "../context/AuthContext";
import { errorMessage } from "../lib/api";

const HomeIntro = () => (
  <div className="tr-fade-up mb-6 w-full max-w-md text-center" data-testid="home-intro">
    <h1 className="text-sm font-bold leading-snug text-white">
      Expedientes TR — Intranet de expedientes de crédito de Servicios Digitales TR, S.A. de C.V., SOFOM, E.N.R.
    </h1>
  </div>
);

export default function LoginPage({ home = false }) {
  const { login } = useAuth();
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const onSubmit = async (e) => {
    e.preventDefault();
    setError("");
    setLoading(true);
    try {
      await login(email, password);
      navigate("/", { replace: true });
    } catch (err) {
      setError(err.response?.status === 401 ? "Correo o contraseña incorrectos" : errorMessage(err, "No se pudo iniciar sesión, intenta de nuevo"));
    } finally {
      setLoading(false);
    }
  };

  const inputCls = "h-12 w-full rounded-[12px] border border-[#d7e0ec] bg-white px-4 text-sm text-[#182235] outline-none transition-colors focus:border-[#0f5ef7] focus:ring-2 focus:ring-[#cfe0ff]";

  return (
    <div
      className="relative flex min-h-screen flex-col items-center justify-center overflow-hidden px-4 py-10"
      style={{ background: "radial-gradient(circle at 15% 20%, rgba(49,165,255,.25), transparent 30%), radial-gradient(circle at 85% 15%, rgba(19,182,122,.18), transparent 28%), linear-gradient(180deg,#0b1220 0%,#0d1730 100%)" }}
      data-testid={home ? "home-page" : "login-page"}
    >
      {home && <HomeIntro />}
      <div className="tr-card tr-fade-up w-full max-w-md p-7 sm:p-9">
        <div className="mb-7 flex items-center gap-4">
          <BrandLogo size="h-20 w-20" testId="login-logo" />
          <div>
            <div className="tr-eyebrow">Intranet privada</div>
            <h1 className="text-2xl font-extrabold tracking-tight text-[#182235]">Expedientes de crédito</h1>
            <p className="text-xs text-[#5b667a]" data-testid="login-legal-name">Servicios Digitales TR, S.A. de C.V., SOFOM, E.N.R.</p>
          </div>
        </div>
        <form onSubmit={onSubmit} className="space-y-4" data-testid="login-form">
          <label className="block space-y-1.5">
            <span className="text-sm font-semibold text-[#182235]">Correo electrónico</span>
            <input type="email" required autoComplete="username" value={email} onChange={(e) => setEmail(e.target.value)} className={inputCls} placeholder="nombre@serviciosdigitalestr.com" data-testid="login-email-input" />
          </label>
          <label className="block space-y-1.5">
            <span className="text-sm font-semibold text-[#182235]">Contraseña</span>
            <input type="password" required autoComplete="current-password" value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} data-testid="login-password-input" />
          </label>
          {error && (
            <div role="alert" className="flex items-center gap-2 rounded-[12px] border border-[#f3c9c9] bg-[#fdf0ef] px-3 py-2.5 text-sm font-medium text-[#b42318]" data-testid="login-error">
              <AlertCircle className="h-4 w-4 shrink-0" />
              {error}
            </div>
          )}
          <button type="submit" disabled={loading} className="tr-btn-primary h-12 w-full text-base" data-testid="login-submit-button">
            {loading ? <Loader2 className="h-5 w-5 animate-spin" /> : "Entrar"}
          </button>
        </form>
        <p className="mt-6 flex items-start gap-2 text-xs text-[#5b667a]">
          <Lock className="mt-0.5 h-3.5 w-3.5 shrink-0" />
          Acceso solo para personal autorizado. Si necesitas una cuenta, solicítala al administrador.
        </p>
      </div>
      <LegalFooter className="mt-6" />
    </div>
  );
}
